<template>
  <div id="map-canvas">
  </div>
</template>

<script>
import {Loader} from 'google-maps';
import platformSettings from '~config/settings'
import { mapState} from "vuex";

export default {
  data () {
    return {
      geoRoutes: [],
      map: null,
      google: null,
      directionsService: null,
      directionsDisplay: null,
    }
  },
  methods: {
    addRoute(waypoints){
      const stops =  waypoints.slice(1, waypoints.length-1).map(point => ({location: point}))
      this.directionsService.route(
          {
            origin: waypoints[0],
            destination: waypoints[waypoints.length - 1],
            waypoints: stops,
            travelMode: this.google.maps.TravelMode.DRIVING,
            optimizeWaypoints: true
          },
          (response, status) => {
            if (status === this.google.maps.DirectionsStatus.OK) {
              this.directionsDisplay.setDirections(response)
            } else {
              console.log("Directions failed", status)
            }
          }
      )

    }
  },
  computed: mapState('jobs', ['selectedItems']),
  async created() {
    this.unsubscribe = this.$store.subscribe(( mutation ) => {
      if (mutation.type.startsWith('jobs/')) {
          let waypoints = this.selectedItems.reduce(
              (address, item) => {
                address.push(item.vendorAddress)
                address.push(item.destinationString)
                return address
              },
              []
          )
          waypoints = [... new Set(waypoints)]
          if (waypoints.length > 1) {
            this.addRoute(waypoints)
          } else {
            this.directionsDisplay.setDirections({ routes: [] })
          }
      }
    })
    const loader = new Loader(platformSettings.googleMapsApiKey)
    this.google = await loader.load()
    this.directionsService = new this.google.maps.DirectionsService()
    this.map = new this.google.maps.Map(
        document.getElementById("map-canvas"),
        {
          center: {lat: 50, lng: 10},
        zoom: 6
        }
    )
    this.directionsDisplay = new this.google.maps.DirectionsRenderer({
        map: this.map
    })
  },
  beforeDestroy() {
    this.unsubscribe()
  }
}

</script>

<style>
#map-canvas {
  height: 400px;
  width: 100%;
}
</style>